import useLocalStorage from '~/portal/hooks/useLocalStorage'
import { RoutingOption, RoutingSettings } from '~/shared/types/portal'

// only holds a routing choice the visitor made explicitly; the portal's configured
// default is never written here, so later changes to it still reach the visitor
export const ROUTING_OVERRIDE_KEY = 'portal.routingOverride'

export const FALLBACK_ROUTING_SETTINGS: RoutingSettings = {
  routing: RoutingOption.BROWSER,
  credentialsEnabled: true,
}

export const resolveRoutingSettings = (
  override?: RoutingSettings | null,
  portalSettings?: RoutingSettings,
): RoutingSettings => override ?? portalSettings ?? FALLBACK_ROUTING_SETTINGS

export const useRoutingSettings = (
  portalSettings?: RoutingSettings,
): [RoutingSettings, (settings: RoutingSettings) => void] => {
  const [override, setOverride] = useLocalStorage<RoutingSettings | undefined>(ROUTING_OVERRIDE_KEY, undefined)

  return [resolveRoutingSettings(override, portalSettings), setOverride]
}
